import { render, staticRenderFns } from "./WaiterProgressHistoriesTable.vue?vue&type=template&id=aa6fe7ea&scoped=true&lang=pug"
import script from "./WaiterProgressHistoriesTable.vue?vue&type=script&lang=ts"
export * from "./WaiterProgressHistoriesTable.vue?vue&type=script&lang=ts"
import style0 from "./WaiterProgressHistoriesTable.vue?vue&type=style&index=0&id=aa6fe7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6fe7ea",
  null
  
)

export default component.exports